export const ChatMessagesDataLayerSymbol = Symbol.for("ChatMessagesDataLayer");
